import { render } from "./MultiVideoProjectSuccess.vue?vue&type=template&id=086c602e&scoped=true"
import script from "./MultiVideoProjectSuccess.vue?vue&type=script&lang=ts"
export * from "./MultiVideoProjectSuccess.vue?vue&type=script&lang=ts"

import "./MultiVideoProjectSuccess.vue?vue&type=style&index=0&id=086c602e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-086c602e"

export default script